var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.335,
    cy: 40.335,
    r: 33.335,
    fill: "#00A47E",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.047 50.827a2.907 2.907 0 0 1-2.063-.853l-7.91-7.91a2.913 2.913 0 0 1 0-4.124 2.913 2.913 0 0 1 4.123-.003l5.85 5.85 13.76-13.76a2.917 2.917 0 0 1 4.123 4.127l-15.82 15.82c-.57.57-1.316.853-2.063.853",
    fill: "#00A47E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.7dc7e3018bf98556e03c737973669313.svg";
export { ForwardRef as ReactComponent };